import React from 'react'
import { Outlet } from 'react-router-dom'
import { Icon, IconLibrary, NavBar, useAppLinksNavSection } from '../../../components'
import '../index.css'

const App = ({ appName }) => {

  // Länkar live in the sidebar rather than as a right rail on Hem — null while
  // loading, and for a non-admin with no links, in which case no section renders.
  const lankar = useAppLinksNavSection(appName)

  const links = [
    {
      type: "link",
      relativePath: "",
      label: "Hem",
      icon: <Icon name="home" />,
    },
    {
      type: "section",
      label: "Vyer",
      links: [
        {
          type: "link",
          relativePath: "list",
          label: "Stories",
          icon: <IconLibrary name="list" />,
        },
        {
          type: "link",
          relativePath: "deltagare",
          label: "Externa deltagare",
          icon: <IconLibrary name="person" />,
        },
      ],
    },
    ...(lankar ? [lankar] : []),
  ]

  return (
    <div className={"app-container" + (appName ? " " + appName : "")}>

      <NavBar links={links} appName={appName} />

      <div className="app-content">
        <Outlet context={appName} />
      </div>

    </div>
  )
}

export default App
